import { Button, Row, Col } from 'antd';
import { passwordReset as config } from '../forms/formConfig';
import { ssFormUtils } from '@bit/ui-common.ui-components/ss-utils';
import { HomeCaptchaForm} from '@bit/ui-common.ui-components/ss-components';
const 
{ key } = config,
{ generateInitState } = ssFormUtils;

export default class extends React.Component {
    constructor(props) { 
        super(props); 
    }

    resetForm() {
        const { services: { storeForm }} = this.props;
        storeForm(key, generateInitState(config));
    }

    render() {
        const { 
            services, 
            state: { 
                registrationForm, 
                captcha: { field }, 
                login: { 
                    showLoginStatusModal, 
                    loginButtonDisabled, 
                    passwordResetRequest: { status }
                }
            },
            captchaInput
        } = this.props,
        form = registrationForm[key];
        return (
            <div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '15px' }}>
                    <Col>
                        <div style={{ marginBottom: '8px' }}>
                            <Button
                                size='small'
                                icon='check-circle'
                                type='primary'
                                loading={status === 'pending' ? true : false}
                                style={{ width: '241px', borderRadius: '20px' }}
                                disabled={status === 'success' || status === 'failure' ? true : loginButtonDisabled}
                                onClick={() => { if (registrationForm.hasOwnProperty(key)) {
                                    services.requestPasswordReset({ emailAddress: form.userIdOrEmail, captcha: captchaInput });
                                }}}
                            >
                                {'Request Password Reset'}
                            </Button>
                        </div>
                        <div>
                            <Button
                                size='small'
                                icon='left'
                                type='danger'
                                style={{ width: '241px', borderRadius: '20px' }}
                                onClick={() => {
                                    if (!loginButtonDisabled) services.toggleAfspLoginButtonDisable();
                                    services.toggleAfspPasswordResetModal();
                                    services.resetCaptchaValidation();
                                    this.resetForm();
                                    setTimeout(() => services.resetAfspPasswordResetRequest(), 0);
                                }}
                            >
                                {'Back'}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}